import { State } from 'xstate';
import { addOnsConfiguration } from './machine';

export type AddOnsConfigurationMachine = typeof addOnsConfiguration;
export type AddOnsConfigurationMachineState = State<
  AddOnsConfigurationMachine['context']
>;

export const getAddonsState = (
  machineState: AddOnsConfigurationMachineState
) => ({
  configureAllocationsStep: machineState.matches('configureAllocationsStep'),
  configureAllocationsStepLoading: machineState.matches(
    'configureAllocationsStep.initialize'
  ),
  previewAllocationsStep: machineState.matches('previewAllocationsStep'),
  previewAllocationsLoading: machineState.matches(
    'configureAllocationsStep.previewAllocations'
  ),
  updateAllocationsLoading: machineState.matches(
    'previewAllocationsStep.updateAllocations'
  ),
  updateSuccess: machineState.matches('previewAllocationsStep.updateSuccess'),
});

export const getAddonsComponents = (
  machineState: AddOnsConfigurationMachineState
) => ({
  components: machineState.context.components,
});

export const getAllocationsPreview = (
  machineState: AddOnsConfigurationMachineState
) => {
  return { allocationsPreview: machineState.context.allocationsPreview };
};

export const getAllocations = (machineState: AddOnsConfigurationMachineState) =>
  machineState.context.allocations;

export const getAllocationError = (
  machineState: AddOnsConfigurationMachineState
) => ({
  error: machineState.context.error,
});

export const addConfigurationSelectors = {
  getAddonsState,
  getAddonsComponents,
  getAllocationsPreview,
  getAllocations,
  getAllocationError,
};
